//@ts-nocheck
import formElementMixin from "@banno/jha-wc/src/js/mixins/form-element-mixin";
import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { postRequest } from "../../utils/jha-fetch";
import { Apis } from "../../utils/api-constants";
import { showToast } from "@banno/jha-wc/src/js/utils/toast-util.js";
import { GlobalVariables } from "../../utils/constants";
import { getErrorMessage } from "../../utils/getErrorMessage";
import { resolveAuthFlowErrorMessage } from "../../utils/user-account-login-lock";
import "../../Components/Loader";

@customElement("reset-password")
export class ResetPassword extends formElementMixin(LitElement) {
  constructor() {
    super();
  }
  @property({ type: Object })
  formData = {
    userId: "",
  };

  @property({ type: Boolean })
  resetConfirm = false;

  @property({ type: Boolean })
  apiLoading = false;

  static get styles() {
    return [
      css`
        jha-card {
          width: 508px;
          padding: 48px;
          position: relative;
          border-radius: 23px;
        }
        jha-form-text-input {
          min-width: 500px;
        }
        jha-button {
          width: 100%;
        }
        jha-form-row {
          margin-top: 50px;
          margin-bottom: 50px;
        }
        img {
          width: 112px;
          height: 112px;
        }
        #loginBg {
          background-color: #06185f;
          display: flex;
          align-items: center;
          height: 100vh;
          width: 100vw;
        }
        #avatarDiv {
          display: flex;
          justify-content: center;
          width: 100%;
        }
        #submitBtn {
          width: 90px;
        }
      `,
    ];
  }

  async onSendLinkClick() {
    this.apiLoading = true;
    const resetPassword = await postRequest<{ userId: string }>(
      Apis.FORGOT_PASSWORD + `?userId=${this.formData.userId.trim()}`
    );

    let resetPasswordResponse: any = null;

    if (resetPassword?.messageStatus !== null && resetPassword?.description !== "Bad Request") {
      resetPasswordResponse = await resetPassword.json();
    }

    if (resetPassword?.messageStatus === null) {
      this.apiLoading = false;
      this.resetConfirm = true;
    } else if (
      resetPasswordResponse &&
      resetPasswordResponse.details &&
      Array.isArray(resetPasswordResponse.details) &&
      resetPasswordResponse.details.length > 0
    ) {
      this.apiLoading = false;
      const errMsg = resolveAuthFlowErrorMessage(
        resetPasswordResponse.details,
        getErrorMessage,
      );
      showToast({
        message: errMsg,
        role: "danger",
        duration: GlobalVariables.TOAST_TIMEOUT,
      });

    } else if (resetPassword?.description === "Bad Request") {
      this.apiLoading = false;
      showToast({
        message: "Access Denied",
        role: "danger",
        duration: GlobalVariables.TOAST_TIMEOUT,
      });

    }
    else {
      this.apiLoading = false;
      showToast({
        message: "Something went wrong, please try again.",
        role: "danger",
        duration: GlobalVariables.TOAST_TIMEOUT,
      });
    }
  }

  render() {
    if (this.resetConfirm) {
      return html`
        ${this.apiLoading ? html`<circle-loader></circle-loader>` : undefined}
        <div id="loginBg">
          <jha-card>
            <div id="avatarDiv">
              <img src="circle-checkmark-filled.png" />
            </div>
            <jha-form-row>
              <div id="avatarDiv">
                <h2>Confirmation Sent</h2>
              </div>
            </jha-form-row>
            <jha-form-row>
              <div id="avatarDiv">
                <h3>
                  An email with a reset link has been sent. The link will expire in 24 hours. If you encounter any
                  problems, please don't hesitate to contact us.
                </h3>
              </div>
            </jha-form-row>
          </jha-card>
        </div>
      `;
    } else {
      return html`
        <div id="loginBg">
          <jha-card>
            <form>
              <div id="avatarDiv">
                <img src="/jha-logo.png" alt="JHA" />
              </div>
              <jha-form-row>
                <div id="avatarDiv">
                  <h2>Reset Password</h2>
                </div>
              </jha-form-row>
              <jha-form-row>
                <div id="avatarDiv">
                  <h3>
                    Enter the user ID associated with your JHA account. If you are registered in our database, an email
                    with a reset link will be sent.
                  </h3>
                </div>
              </jha-form-row>
              <jha-tooltip bottom text="Enter the user ID associated with your JHA account.">
                <jha-form-row>
                  <jha-form-text-input data-auto-id="userIdInput" label="User ID" required="" warning="User ID Required."
                    type="text" data-id="userId" @change=${this.inputValueChange} maxlength="256" outline>
                  </jha-form-text-input>
                </jha-form-row>
              </jha-tooltip>
              <jha-form-row>
                <jha-tooltip bottom text="Click to send a reset password link to associated email.">
                  <jha-button data-auto-id="submitBtn" large type="submit" ?disabled=${!this.formValid} sync
                    @click=${this.onSendLinkClick}>
                    Send Link
                  </jha-button>
                </jha-tooltip>
                <jha-tooltip bottom text="Click to cancel and go back to login page.">
                  <jha-button data-auto-id="cancelBtn" large type="button" tertiary sync @click=${()=> {
        window.location.href = "/login";
        }}>
                    Cancel
                  </jha-button>
                </jha-tooltip>
              </jha-form-row>
            </form>
          </jha-card>
        </div>
      `;
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "reset-password": ResetPassword;
  }
}
